import { useState } from 'react';
import { ConfirmationDialog } from '~/shared/components/ui';
import { CaptionButton } from '~/shared/components/ui/Button';

const sampleMessage = {
  id: 'C0000001',
  value: { $1: 'サンプル' },
};
export const UISampleDialogs = () => {
  const [result, setResult] = useState('');
  const [isShowConfirm, setIsShowConfirm] = useState(false);

  return (
    <div className="categories">
      <h3 id="dialog">確認ダイアログ</h3>
      <div className="input-line">
        <div className="item-group-100">
          <div className="w-33">
            <CaptionButton
              buttonType="basic"
              caption="確認する"
              name=""
              onClick={() => {
                setResult('');
                setIsShowConfirm(true);
              }}
            />
            <ConfirmationDialog
              isOpen={isShowConfirm}
              messageLabelId={sampleMessage}
              viewMessage={sampleMessage}
              onDecision={() => {
                setResult('確定しました');
                setIsShowConfirm(false);
              }}
              onCancel={() => {
                setResult('キャンセルしました');
                setIsShowConfirm(false);
              }}
            />
          </div>
          <div className="w-66">
            <pre className="output">{result}</pre>
          </div>
        </div>
      </div>
    </div>
  );
};
